import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.dom-exception.stack.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "template"
};
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = {
  class: "block h-full p-6"
};
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-4 pb-6"
};
const _hoisted_5 = {
  class: "flex items-start justify-between"
};
const _hoisted_6 = {
  class: "flex flex-col gap-0.5"
};
const _hoisted_7 = {
  class: "text-xs text-muted-foreground"
};
const _hoisted_8 = {
  class: "flex"
};
const _hoisted_9 = {
  key: 0,
  class: "text-foreground font-medium text-sm"
};
const _hoisted_10 = {
  class: "text-foreground font-medium text-sm"
};
const _hoisted_11 = {
  class: "flex items-center justify-between gap-3"
};
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col gap-0.5"
};
const _hoisted_13 = {
  class: "text-muted-foreground text-xs"
};
const _hoisted_14 = {
  class: "flex items-center gap-2"
};
const _hoisted_15 = ["href"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 0,
  class: "h-3.5 w-3.5 rounded-full border-2 border-orange-600 border-t-transparent animate-spin"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = {
  key: 0,
  class: "rounded-[var(--radius)] bg-card p-6 border border-border"
};
const _hoisted_20 = {
  class: "flex flex-col gap-2"
};
const _hoisted_21 = {
  class: "flex flex-col gap-1"
};
const _hoisted_22 = {
  class: "text-xs text-muted-foreground"
};
const _hoisted_23 = {
  class: "text-sm font-medium text-foreground"
};
const _hoisted_24 = {
  class: "flex items-center justify-between gap-3"
};
const _hoisted_25 = {
  class: "flex items-center gap-3 justify-start text-muted-foreground text-sm"
};
const _hoisted_26 = {
  class: "flex gap-2"
};
const _hoisted_27 = {
  key: 0,
  class: "flex items-center gap-2 rounded-full px-5 py-2 h-8 bg-green-600/10"
};
const _hoisted_28 = {
  class: "text-green-600 text-xs"
};
const _hoisted_29 = ["disabled"];
import { ref, computed, getCurrentInstance, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/css'

import TipTapEditor2 from "@/features/document-editor/ui/TipTapEditor2.vue";
import { getParticipantListNotarial, verifyChainSign, signNotary, rejectNotary, getCurrentSignParticipant, getSignatureList } from "@/entities/transaction";
import { useParticipantTypes } from "@/entities/directory";
import DialogWrapper from "@/shared/ui/custom/components/DialogWrapper.vue";
import { getClientIP, generateDeviceFingerprint, getUserAgent } from "@/shared/lib/signatureHelpers";
import { CATEGORY_CODES } from "@/shared/lib/constants";
import nclayerPort from "@/shared/nclayer";
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import { Dialog, DialogContent, DialogTitle } from "@/shared/ui/dialog";
import dateFormat from "@/shared/lib/date-format";
// eslint-disable-next-line no-unused-vars
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import { EgovSignQr } from "@/shared/ui/qr-code";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/shared/ui/dropdown-menu";
import { SectionHeading } from "@/shared/ui/section-heading";
import { useStore } from "vuex";
import { useCentrifuge, centrifugeManager } from "@/shared/lib/centrifuge";
import { NOTIFICATIONS_CHANNEL_PREFIX } from "@/entities/notification";
export default {
  __name: 'NotarialActionSign',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const STATUS = {
      PENDING: "PENDING",
      SIGNING: "SIGNING",
      SIGNED: "SIGNED",
      REJECTED: "REJECTED",
      CANCELLED: "CANCELLED"
    };
    const ALGORITHM = {
      SHA256: "SHA256"
    };
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const {
      t
    } = useI18n();
    const store = useStore();
    const instance = getCurrentInstance();
    const {
      fetchParticipantTypes,
      getReferenceTitle
    } = useParticipantTypes();
    const loading = ref(false);
    const loadingOverlay = ref(false);
    const templateLang = ref("ru");
    const currentSignerData = ref(null);
    const participants = ref([]);
    const isChainValid = ref(false);
    const verifying = ref(false);
    const signingInProgress = ref(false);
    const rejectionInProgress = ref(false);
    const showRejectDialog = ref(false);
    const rejectReason = ref(null);
    const signatureList = ref(null);
    const showSignInfoDialog = ref(false);
    const selectedParticipantSignInfo = ref(null);
    const rejectParticipantUuid = ref(null);
    const editorRef = ref(null);
    const dontSignCodes = computed(() => props.template?.participant_dont_sign_type_codes || []);
    const uuid = computed(() => props.form?.id || route.params.id);
    const transactionUuid = computed(() => props.form?.uuid || uuid.value);
    const qrCloseSignal = ref(0);
    const qrCloseTargetUuid = ref("");
    const isInheritance = computed(() => props.form.category_code === CATEGORY_CODES.SVID_PRAVO_NASLED);
    const isApplications = computed(() => props.form.category_code === CATEGORY_CODES.APPLICATIONS);
    const titleKey = computed(() => {
      return {
        kz: "content_kz",
        ru: "content",
        en: "content_en"
      }[templateLang.value];
    });
    const templateJson = computed(() => {
      return props.form[titleKey.value] ? JSON.parse(JSON.stringify(props.form[titleKey.value])) : null;
    });
    const allParticipants = computed(() => {
      return currentSignerData.value?.all_participants || [];
    });
    const filteredParticipants = computed(() => participants.value.filter(p => !dontSignCodes.value.includes(p.participant_type_code)));
    const allSigned = computed(() => {
      if (participants.value.length === 0) return false;
      if (filteredParticipants.value.length === 0) return true;
      return filteredParticipants.value.every(p => p.status === STATUS.SIGNED);
    });
    const isCompleted = computed(() => {
      return signatureList.value?.some(s => !s.participant_uuid && s.status === STATUS.SIGNED) || false;
    });
    const noSigningParticipants = computed(() => {
      return participants.value.length > 0 && filteredParticipants.value.length === 0;
    });
    const canSign = computed(() => {
      if (noSigningParticipants.value) {
        return allSigned.value && !signingInProgress.value;
      }
      return allSigned.value && isChainValid.value && !signingInProgress.value;
    });
    const sectionSignInfo = computed(() => {
      const info = selectedParticipantSignInfo.value;
      const notSpecified = t("Не указано");
      return [{
        title: t("Действие участника"),
        items: [{
          label: t("Дата и время действия"),
          values: [{
            text: formatDate(info?.created_at) || notSpecified
          }]
        }, {
          label: t("ФИО участника"),
          values: [{
            text: info?.participant ? `${info.participant.first_name} ${info.participant.last_name}` : notSpecified
          }]
        }, {
          label: t("ИИН участника"),
          values: [{
            text: info?.participant?.identifier || notSpecified
          }]
        }, {
          label: t("Статус"),
          values: [{
            text: getStatusLabel(info?.status) || notSpecified
          }]
        }, {
          label: t("URL-адрес файла подписи"),
          values: [{
            text: info?.signature_file_url || notSpecified
          }]
        }, {
          label: t("Алгоритм подписи"),
          values: [{
            text: info?.algorithm === ALGORITHM.SHA256 ? t("ЭЦП") : t("Подпись рукой")
          }]
        }, {
          label: t("Причина отказа"),
          values: [{
            text: info?.rejection_reason || notSpecified
          }],
          showIf: info?.status === STATUS.REJECTED
        }, {
          label: t("Примечание"),
          values: [{
            text: info?.notes || notSpecified
          }]
        }]
      }];
    });
    const participantActions = computed(() => {
      return [{
        label: t("Данные подписание"),
        action: "show",
        icon: "huge-document-info"
      }, ...(!isCompleted.value ? [{
        label: "Отклонить",
        type: "danger",
        action: "reject",
        icon: "huge-close"
      }] : [])];
    });
    const notaryFullName = computed(() => {
      const info = props.form?.notary_info || {};
      if (info.fio) return info.fio;
      return `${info.last_name || ""} ${info.first_name || ""} ${info.middle_name || ""}`.trim();
    });
    const overlayTitle = computed(() => {
      return t("Идет регистрация действия");
    });
    const overlaysubTitle = computed(() => {
      return t("Мы регистрируем данные в цифровом хранилище,\n" + "это займет совсем немного времени");
    });
    async function initializeData() {
      loading.value = true;
      try {
        const [participantRes, currentSignerRes] = await Promise.all([getParticipantListNotarial(uuid.value), getCurrentSignParticipant(uuid.value)]);
        const participantsList = participantRes?.payload?.items || [];
        const currentSignerDataVal = currentSignerRes?.payload || null;
        participants.value = participantsList.map(p => {
          const signInfo = currentSignerDataVal?.all_participants?.find(a => a.uuid === p.uuid) || {};
          return {
            ...p,
            ...signInfo,
            sign_link: `${window.__CONFIG__.VUE_APP_CLIENT_DOMAIN}/client/dashboard/${uuid.value}/?participant_uuid=${p.uuid}&template_category_code=${props.form?.template_category_code || ""}`,
            sign_link_display: `${window.__CONFIG__.VUE_APP_CLIENT_DOMAIN}/client/dashboard/${uuid.value}`
          };
        });
        currentSignerData.value = currentSignerDataVal;
        await verifyChain();
        await fetchParticipantTypes();
        await fetchSignatureList();
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false;
      }
    }
    async function verifyChain() {
      if (!uuid.value) return;
      verifying.value = true;
      try {
        const {
          payload
        } = await verifyChainSign(uuid.value);
        const {
          ok,
          is_valid
        } = payload || {};
        isChainValid.value = Boolean(ok && is_valid);
      } finally {
        verifying.value = false;
      }
    }
    async function fetchSignatureList() {
      try {
        const {
          success,
          payload
        } = await getSignatureList(uuid.value);
        if (success && payload) {
          signatureList.value = payload.signatures || [];
        }
      } catch (e) {
        console.error("fetchSignatureList failed", e);
      }
    }
    function getParticipantStatus(participant) {
      const participantSignature = signatureList.value?.find(s => s.participant?.uuid === participant.uuid);
      return participantSignature?.status || allParticipants.value.find(p => p.uuid === participant.uuid)?.status;
    }
    async function signNotaryWithEDS() {
      if (!canSign.value) return;
      loadingOverlay.value = true;
      try {
        const transactionHash = currentSignerData.value?.transaction_hash || String(uuid.value);
        const base64Data = btoa(unescape(encodeURIComponent(transactionHash)));
        const result = await nclayerPort.sign(base64Data);
        if (result.signatures?.length) {
          await signByNotary(result.signatures[0]);
        }
      } catch (e) {
        showErrorToast();
        loadingOverlay.value = false;
      } finally {
        loadingOverlay.value = false;
      }
    }
    async function signByNotary(signatureData) {
      if (!isChainValid.value || !uuid.value) return;
      try {
        const params = {
          signature_data: signatureData,
          algorithm: ALGORITHM.SHA256,
          content_type: "application/json",
          ip_address: await getClientIP(),
          user_agent: getUserAgent(),
          device_fingerprint: generateDeviceFingerprint(),
          notes: ""
        };
        const {
          success,
          payload
        } = await signNotary(uuid.value, params);
        if (success && payload) {
          instance.root.refs.toast.addToast({
            type: "success",
            title: "Документ успешно подписан",
            description: isInheritance.value ? "Документ был успешно подписан всеми участниками наследственного дела" : "Документ был успешно подписан всеми участниками нотариального действия"
          });
          await new Promise(resolve => setTimeout(resolve, 800));
          router.push({
            name: isInheritance.value ? "hereditary_case_view" : "notarial_action_view",
            params: {
              id: uuid.value
            }
          });
        } else {
          showErrorToast();
        }
      } catch (e) {
        showErrorToast();
      } finally {
        loading.value = false;
      }
    }
    async function rejectByNotary() {
      if (!rejectParticipantUuid.value || !rejectReason.value) return;
      showRejectDialog.value = false;
      rejectionInProgress.value = true;
      try {
        const signatureEntry = signatureList.value?.find(l => l.participant_uuid === rejectParticipantUuid.value);
        if (!signatureEntry) return;
        const result = await rejectNotary(signatureEntry.uuid, {
          rejection_reason: rejectReason.value
        });
        if (result.success) {
          ElMessage.warning(result.payload?.message);
          rejectReason.value = null;
          rejectParticipantUuid.value = null;
        }
      } finally {
        rejectionInProgress.value = false;
      }
    }
    function showInfoSign(participant) {
      const participantSignature = signatureList.value?.find(s => s.participant?.uuid === participant.uuid);
      if (!participantSignature) {
        ElMessage?.warning(t("Это участник не найден внутри подписанты"));
        return;
      }
      selectedParticipantSignInfo.value = participantSignature;
      showSignInfoDialog.value = true;
    }
    function formatDate(date) {
      return date ? dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm") : t("Не указано");
    }
    function getStatusLabel(status) {
      const labels = {
        [STATUS.PENDING]: t("Ожидает"),
        [STATUS.SIGNING]: t("На подписании"),
        [STATUS.SIGNED]: t("Подписано"),
        [STATUS.REJECTED]: t("Отклонено"),
        [STATUS.CANCELLED]: t("Отменена")
      };
      return labels[status] || t("Не указано");
    }
    function getStatusClasses(status) {
      return {
        "bg-green-600/10": status === STATUS.SIGNED,
        "bg-orange-400/20": status === STATUS.PENDING,
        "bg-orange-400/10": status === STATUS.SIGNING,
        "bg-red-400/20": status === STATUS.REJECTED || status === STATUS.CANCELLED
      };
    }
    function getStatusTextClasses(status) {
      return {
        "text-green-600": status === STATUS.SIGNED,
        "text-orange-600": status === STATUS.PENDING,
        "text-orange-500": status === STATUS.SIGNING,
        "text-red-400": status === STATUS.REJECTED || status === STATUS.CANCELLED
      };
    }
    function copy(value) {
      navigator.clipboard.writeText(value);
      ElMessage.success(t(`Скопировано: ${value}`));
    }
    function handleActions(command) {
      const {
        action,
        item
      } = command;
      if (action === "show") {
        showInfoSign(item);
      }
      if (action === "reject") {
        rejectParticipantUuid.value = item.uuid;
        showRejectDialog.value = true;
      }
    }
    function getVerificationMessage() {
      if (verifying.value) return t("Проверка подписей…");
      if (allSigned.value) {
        if (!isChainValid.value) return t("Цепочка подписей невалидна");
        return filteredParticipants.value.length > 0 ? t("Участники произвели оплату и подписали документы") : t("Готово к подписанию нотариусом");
      }
      return t("Дождитесь подписания всех участников");
    }
    function showErrorToast() {
      instance.root.refs.toast.addToast({
        type: "error",
        title: "Ошибка",
        description: "Ошибка при подписании ЭЦП"
      });
    }
    function changeLang(lang) {
      templateLang.value = lang;
    }
    const SIGN_EVENT_CODES = ["PARTICIPANT_SIGNED", "ALL_PARTICIPANTS_SIGNED"];
    function eventMatchesTransaction(opts) {
      const ours = [uuid.value, transactionUuid.value].filter(Boolean).map(String);
      const eventIds = [opts?.transaction_id, opts?.transaction_uuid, opts?.object_uuid].filter(Boolean).map(String);
      if (!eventIds.length) return true;
      return eventIds.some(id => ours.includes(id));
    }
    function isSignDoneEvent(eventCode) {
      return SIGN_EVENT_CODES.includes(eventCode) || /REJECT/i.test(eventCode || "");
    }
    async function handleSignWsEvent(data) {
      const payload = data?.payload || {};
      const opts = payload.options || {};
      const eventCode = payload.event;
      if (!eventMatchesTransaction(opts)) return;
      if (!isSignDoneEvent(eventCode)) return;
      qrCloseTargetUuid.value = eventCode === "ALL_PARTICIPANTS_SIGNED" ? "" : opts?.signer?.uuid || "";
      qrCloseSignal.value += 1;
      await initializeData();
    }
    const selfUuid = store.getters.get_self_user?.uuid;
    if (selfUuid) {
      centrifugeManager.init();
      useCentrifuge(`${NOTIFICATIONS_CHANNEL_PREFIX}${selfUuid}`, handleSignWsEvent);
    }

    // created logic
    watch(uuid, val => {
      if (val) initializeData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(TipTapEditor2, {
        mode: "preview",
        "with-border": false,
        templateLang: templateLang.value,
        json: templateJson.value,
        signatures: signatureList.value || [],
        "onChange:lang": changeLang,
        ref_key: "editorRef",
        ref: editorRef
      }, null, 8, ["templateLang", "json", "signatures"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(SectionHeading), {
        title: _ctx.$t('Подписание'),
        description: !participants.value?.length ? _ctx.$t(isInheritance.value ? 'У вас не выбраны участники для данного наследственного дела' : 'У вас не выбраны участники для данного нотариального действия') : '',
        "title-class": "text-base truncate"
      }, null, 8, ["title", "description"]), participants.value?.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredParticipants.value, participant => {
        return _openBlock(), _createElementBlock("div", {
          key: participant.uuid,
          class: "relative rounded-[var(--radius)] bg-card p-4 border border-border flex flex-col gap-4"
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Подписание")), 1), _createElementVNode("div", _hoisted_8, [_unref(getReferenceTitle)(participant.participant_type_code) ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(`${_unref(getReferenceTitle)(participant.participant_type_code)} – `), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_10, _toDisplayString(participant.first_name) + " " + _toDisplayString(participant.last_name), 1)])]), _createVNode(_unref(EgovSignQr), {
          "transaction-uuid": transactionUuid.value,
          "participant-uuid": participant.uuid,
          "participant-name": `${participant.first_name || ''} ${participant.last_name || ''}`.trim(),
          "close-signal": qrCloseSignal.value,
          "close-target-uuid": qrCloseTargetUuid.value
        }, null, 8, ["transaction-uuid", "participant-uuid", "participant-name", "close-signal", "close-target-uuid"])]), _cache[4] || (_cache[4] = _createElementVNode("hr", {
          class: "border-border"
        }, null, -1)), _createElementVNode("div", _hoisted_11, [participant.sign_link ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("Ссылка на подписание")), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("a", {
          href: participant.sign_link,
          target: "_blank",
          class: "text-muted-foreground text-xs break-all hover:underline"
        }, _toDisplayString(participant.sign_link_display), 9, _hoisted_15), _createElementVNode("div", {
          class: "cursor-pointer p-1 rounded hover:bg-muted text-muted-foreground shrink-0",
          onClick: _withModifiers($event => copy(participant.sign_link), ["stop"])
        }, [_createVNode(_component_svg_icon, {
          name: "huge-copy",
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_16)])])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(["flex items-center gap-2 rounded-full px-4 py-1.5 h-8 shrink-0", getStatusClasses(getParticipantStatus(participant))])
        }, [_createElementVNode("span", {
          class: _normalizeClass([getStatusTextClasses(getParticipantStatus(participant)), "text-xs"])
        }, _toDisplayString(getStatusLabel(getParticipantStatus(participant))), 3), getParticipantStatus(participant) === STATUS.SIGNING ? (_openBlock(), _createElementBlock("span", _hoisted_17)) : _createCommentVNode("", true), getParticipantStatus(participant) === STATUS.SIGNED ? (_openBlock(), _createBlock(_unref(DropdownMenu), {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_unref(DropdownMenuTrigger), {
            "as-child": ""
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              name: "huge-down",
              class: _normalizeClass(["w-4 h-4 ml-1 cursor-pointer", getStatusTextClasses(getParticipantStatus(participant))])
            }, null, 8, ["class"])]),
            _: 2
          }, 1024), _createVNode(_unref(DropdownMenuContent), {
            align: "end",
            class: "menu"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(participantActions.value, (action, index) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: action.label
              }, [action.type === 'danger' && index > 0 ? (_openBlock(), _createBlock(_unref(DropdownMenuSeparator), {
                key: 0
              })) : _createCommentVNode("", true), _createVNode(_unref(DropdownMenuItem), {
                variant: action.type === 'danger' ? 'destructive' : undefined,
                class: "w-full !p-0 !m-0",
                onClick: $event => handleActions({
                  action: action.action,
                  item: participant
                })
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [action.icon ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  name: action.icon,
                  class: _normalizeClass(["w-4 h-4", action.type])
                }, null, 8, ["name", "class"])) : _createCommentVNode("", true), _createElementVNode("span", {
                  class: _normalizeClass(["text-xs", action.type])
                }, _toDisplayString(_ctx.$t(action.label)), 3)])]),
                _: 2
              }, 1032, ["variant", "onClick"])], 64);
            }), 128))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)], 2)])]);
      }), 128)), !isApplications.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("Подписание")), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(`Нотариус – ${notaryFullName.value}`), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(getVerificationMessage()), 1), _createElementVNode("div", _hoisted_26, [isCompleted.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("Подписано")), 1)])) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        onClick: signNotaryWithEDS,
        disabled: !canSign.value,
        class: _normalizeClass(["flex h-8 items-center gap-2 rounded-full px-5 text-xs font-medium transition-colors", canSign.value ? 'bg-green-500 text-white cursor-pointer hover:bg-green-700' : 'bg-muted text-muted-foreground cursor-not-allowed'])
      }, _toDisplayString(_ctx.$t("Подписать")), 11, _hoisted_29))])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createVNode(DialogWrapper, {
        modelValue: showRejectDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showRejectDialog.value = $event),
        content: rejectReason.value,
        "onUpdate:content": _cache[1] || (_cache[1] = $event => rejectReason.value = $event),
        title: _ctx.$t('Причина отклонение'),
        onClose: _cache[2] || (_cache[2] = $event => showRejectDialog.value = false),
        onSave: rejectByNotary
      }, null, 8, ["modelValue", "content", "title"]), _createVNode(_unref(Dialog), {
        open: showSignInfoDialog.value,
        "onUpdate:open": _cache[3] || (_cache[3] = $event => showSignInfoDialog.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_unref(DialogContent), {
          class: "sm:max-w-[600px] max-h-[80vh] overflow-auto"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DialogTitle), {
            class: "sr-only"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("Информация о подписи")), 1)]),
            _: 1
          }), _createVNode(InformationLayout, {
            showHeader: false,
            sections: sectionSignInfo.value
          }, null, 8, ["sections"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open"]), loadingOverlay.value ? (_openBlock(), _createBlock(LoadingOverlay, {
        key: 0,
        value: loadingOverlay.value,
        title: overlayTitle.value,
        subtitle: overlaysubTitle.value,
        showSkeleton: false
      }, null, 8, ["value", "title", "subtitle"])) : _createCommentVNode("", true)]);
    };
  }
};